import React from "react";

const InputPhoneV1 = ({
  title,
  value,
  setValue,
  placeholder,
  error,
  type,
  cls,
}) => {
  const onChange = (e) => {
    setValue(
      e.target.value
        .replace(/&/g, "")
        .replace(/</g, "")
        .replace(/>/g, "")
        .replace(/"/g, "")
        .replace(/'/g, "")
        .replace(/`/g, "")
        .replace(/^8/g, "7")
        .replace(/^9/g, "79")
    );
  };
  return (
    <div className="login_form_container-input">
      <p className="login_form-name">{title}:</p>
      <input
        id="inpt_name_id"
        value={value}
        onChange={onChange}
        className={`login_form-inpt ${cls}`}
        type="number"
        placeholder={placeholder}
      />
      <p className="login_inpt_message_error">{error}</p>
    </div>
  );
};

export default InputPhoneV1;
